import React from 'react';
import PropTypes from 'prop-types';
import './Checkbox.scss';

const Checkbox = ({ checked, onChange, className = '' }) => {
   return (
      <div
         className={`checkbox-container ct-flex ct-aiCenter ct-jcCenter ct-relative ${checked ? 'checked' : ''} ${className}`}
      >
         <input
            type="checkbox"
            className="ct-absolute ct-opacity0 ct-whfull ct-noMargin ct-cursor ct-zIndex1"
            checked={checked}
            onChange={e => onChange?.(e.target.checked)}
            onClick={e => e.stopPropagation()}
         />
         <div className="checkbox-inner ct-flexCenter">
            <svg
               viewBox="0 0 24 24"
               fill="none"
               stroke="currentColor"
               strokeWidth="0.1875rem"
               strokeLinecap="round"
               strokeLinejoin="round"
            >
               <polyline points="20 6 9 17 4 12" />
            </svg>
         </div>
      </div>
   );
};

Checkbox.propTypes = {
   checked: PropTypes.bool.isRequired,
   onChange: PropTypes.func,
   className: PropTypes.string,
};

export default Checkbox;
